<template>
  <div class="container">
    <div class="routeList-box" v-for="(item,index) in routeList" :key="index">
      <el-collapse v-model="activeNames">
        <el-collapse-item :title="item.title" :name="index">
          <el-tree
            class="el-tree"
            :data="item.children"
            :render-content="renderContent"
            show-checkbox
             :default-checked-keys="cbbaa"
            node-key="name"
            ref="tree"
            highlight-current
            @node-expand="handleExpand"
            @check="handleCheckChange"
            @getCurrentKey='ca'
            :props="defaultProps"
            
          ></el-tree>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-button @click="rolecautha()" v-if="$store.state.operateMenuSign.indexOf('set-auth') !==-1 &&vac==true" > {{ $t('menu.Confirm') }}</el-button>
  </div>
 
</template>
<script>
import {roleaauth,rolecauth} from '../../api/api'
export default {
  data() {
    return {
      routeList: [

      ],
      defaultProps: {
        children: "children",
        label: "title"
      },
      vac:false,
      activeNames:[0,1,2,3],
      valuea:[],
      valueb:[],
      valuec:[],
      valued:[],
      value:[],
      cbba:[],
      cbbaa:['aa', 'ab', 'ac', 'ba', 'aab', 'aac', 'aad', 'aca', 'acb', 'acc', 'acd', 'ace', 'baa', 'bab', 'bac',]
    };
  },
  mounted() {
    this.changeCss();
    this.quax()
 
  },
  methods: {
         async quax(){   
           this.valuea=[]
           this.valueb=[]
           this.valuec=[]
           this.valued=[]
           this.value=[]
           this.cbba=[]
         let id = sessionStorage.getItem('idd')
       this.dialogVisibleaqx=true
         let param = new URLSearchParams();
     const{data:res}= await roleaauth(param,id)
      if(res.code == 200){
        console.log(1);
          this.$message({
          message: '查询成功',
          type: 'success'
        });
        this.routeList=res.data
       
        let ca = res.data 
        ca.forEach(e => {
          
        //   console.log(e.children);
            let cb = e.children
            cb.forEach(a => {
              if(a.selected == true){
                // console.log(a.name);   
               let ccc= this.cbba
               ccc.push(a.name)
                  
                    
              if(a.children != null){
                // console.log(a.name);
                  let caa =a.children
              caa.forEach(e => {
               
                 let ccb=e.name[0]
                
               if(e.selected== true){
                   if(ccb == 'a'){
                    this.valuea.push(e.name)
                     console.log(this.valuea);
                  
                  
                 }
                 if(ccb == 'b'){
                 
                    this.valueb.push(e.name)
                     console.log(this.valueb);
                  
                 }
                 if(ccb == 'c'){
                    this.valuec.push(e.name)
                    
                     console.log(this.valuec);
                 }
                 if(ccb == 'd'){
                    this.valued.push(e.name)
                     console.log(this.valued);
                   
                 }
               }
                
              //  ccc.push(e.name)
              
                  //  console.log(ccc);
                    // console.log(this.valuea,this.valueb,this.valuec,this.valued);
  
              
          })
          }
          
              }
     
            });
           
           
        });
        
        let aaaaa = this.valuea
        let bbbbb = this.valueb
        let ccccc = this.valuec
        let ddddd = this.valued
        aaaaa.forEach(a => {
          this.cbba.push(a)
        });
        bbbbb.forEach(a => {
          this.cbba.push(a)
        });
        ccccc.forEach(a => {
          this.cbba.push(a)
        });
        ddddd.forEach(a => {
          this.cbba.push(a)
        });
console.log(11111111111,this.cbba);
      }else{
           this.$message.error(res.errorMsg);
      }
     },
	handleExpand() {//节点被展开时触发的事件
		//因为该函数执行在renderContent函数之前，所以得加this.$nextTick()
     	this.$nextTick(()=>{
			this.changeCss();
		})
    },
    renderContent(h, { node, data, store }) {//树节点的内容区的渲染 Function
	  let classname = "";
			// 由于项目中有三级菜单也有四级级菜单，就要在此做出判断
      if (node.level === 3) {
        classname = "foo";
      }
      if (node.level === 2 && node.childNodes.length === 0) {
        classname = "foo";
      }
      return h(
        "p",
        {
          class: classname
        },
        node.label
      );
    },
    changeCss() {
      var levelName = document.getElementsByClassName("foo"); // levelname是上面的最底层节点的名字
      for (var i = 0; i < levelName.length; i++) {
        // cssFloat 兼容 ie6-8  styleFloat 兼容ie9及标准浏览器
        levelName[i].parentNode.style.cssFloat = "left"; // 最底层的节点，包括多选框和名字都让他左浮动
        levelName[i].parentNode.style.styleFloat = "left";
        levelName[i].parentNode.onmouseover = function() {
          this.style.backgroundColor = "#fff";
        };
      }
    },
       handleCheckChange(nodeObj, SelectedObj) {
         this.vac=true
        // console.log(SelectedObj)
      console.log(11111111111,SelectedObj.checkedKeys)   // 这是选中的节点的key数组
      // console.log(SelectedObj.checkedNodes) // 这是选中的节点数组
      let a = SelectedObj.checkedKeys[0] 
      
     
      
    
        if(this.valuea.length>1){
          let aa= this.valuea[0]
          if( this.valuea.indexOf(aa[0]+aa[1])!==-1){
   
      }else{
         this.valuea.push(aa[0]+aa[1])
      }
        }
     if(this.valueb.length>1){
        let bb= this.valueb[0]
         if( this.valueb.indexOf(bb[0]+bb[1])!==-1){
      
      }else{
         this.valueb.push(bb[0]+bb[1])
      }

     }
      if(this.valuec.length>1){
        let cc= this.valuec[0]
        if( this.valuec.indexOf(cc[0]+cc[1])!==-1){
      
      }else{
         this.valuec.push(cc[0]+cc[1])
      }
      }

      if(this.valued.length>1){
          let dd= this.valued[0]
         if( this.valued.indexOf(dd[0]+dd[1])!==-1){

      }else{
         this.valued.push(dd[0]+dd[1])
      }
      }

      if(a[0] == 'a'){
          
         this.valuea = SelectedObj.checkedKeys
         this.valuea.push(a[0]+a[1])
       
           if( this.valuea.indexOf(nodeObj.name[0]+nodeObj.name[1])!==-1){

      }else{
         this.valuea.push(nodeObj.name[0]+nodeObj.name[1])
      }
      }
      if(a[0] == 'b'){
          console.log(123123);
         this.valueb = SelectedObj.checkedKeys
        
          this.valueb.push(a[0]+a[1])
            if( this.valueb.indexOf(nodeObj.name[0]+nodeObj.name[1])!==-1){

      }else{
         this.valueb.push(nodeObj.name[0]+nodeObj.name[1])
      }
      }
      if(a[0] == 'c'){
        
         this.valuec = SelectedObj.checkedKeys
          this.valuec.push(a[0]+a[1])
            if( this.valuec.indexOf(nodeObj.name[0]+nodeObj.name[1])!==-1){

      }else{
         this.valuec.push(nodeObj.name[0]+nodeObj.name[1])
      }
      }
      if(a[0] == 'd'){
        
         this.valued = SelectedObj.checkedKeys
          this.valued.push(a[0]+a[1])
           if( this.valued.indexOf(nodeObj.name[0]+nodeObj.name[1])!==-1){

      }else{
         this.valued.push(nodeObj.name[0]+nodeObj.name[1])
      }
      }
     console.log(this.valuea,this.valueb,this.valuec,this.valued);
  
      },
      ca(vaule){
          console.log(vaule);
      },
       async rolecautha(){   
       this.dialogVisibleaqx=true
         let param = new URLSearchParams();
         
     
           this.value.push(this.valuea)
           this.value.push(this.valueb)
           this.value.push(this.valuec)
           this.value.push(this.valued)
         let  auth =  this.value
         param.append("auth",auth);
        let id =sessionStorage.getItem('idd')
     const{data:res}= await rolecauth(param,id)
      if(res.code == 200){
          this.$message({
          message: '成功',
          type: 'success'
        });

      }else{
           this.$message.error(res.errorMsg);
      }
     },
  }
};
</script>
<style lang="less" scoped>
.container {
  padding: 10px;
}
.routeList-box {

  .el-tree {
    margin: 12px 0;
  }
  /deep/.el-collapse-item__header {
    height: 30px;
    background-color: #f4f4f4;
    padding: 0 5px;
  }
  /deep/.el-icon-arrow-right:before {
    color: #409eff;
  }
}
/deep/ .el-tree-node__content::before {
  content: "";
  padding-left: 10px;
}
/deep/.el-checkbox__input {
  margin-right: 6px;
}
</style>

